// src/i18n.js
import { createI18n } from "vue-i18n";
import zh from "./zh";
import en from "./en";

// 定義多語言的翻譯內容

const messages = {
  zh,
  en,
};

// 創建 i18n 實例
const i18n = createI18n({
  locale: "zh", // 預設語言
  fallbackLocale: "en", // 找不到翻譯時的後備語言
  messages, // 語言包
});

export default i18n;
